/**
 * Implement accessing to a karaoke songs list, favorites list.
 * Inner API realization as an abstract level for specific providers.
 *
 * @module data.provider
 */

'use strict';

var config          = require('../config'),
    badRequestError = {message: 'Bad request error!'};


module.exports = {
    /**
     * Get all karaoke tracks from server or search by given request string (as a part of query string).
     *
     * @param {Object} queryStringSet - set of name-value GET parameters
     * @param {Function} callback - callback function
     */
    getTracks: function ( queryStringSet, callback ) {
        var queryString = '?';

        Object.keys(queryStringSet).forEach(function ( name, index, array ) {
            queryString += name + '=' + queryStringSet[name] + ['&', ''][+(index === array.length - 1)];
        });

        core.backend.request(config.resource + queryString, {
            onload: function ( error, response ) {
                if ( error ) {
                    callback(badRequestError);
                } else {
                    callback(null, response);
                }
            },
            onerror: function () {
                callback(badRequestError);
            }
        });
    },

    /**
     * Return URL for playback.
     *
     * @param {number} trackID - ID of karaoke track
     * @param {Function} callback - callback function
     */
    getPlaybackLink: function ( trackID, callback ) {
        core.backend.request(config.resource + [trackID, config.karaokeLink].join('/'), {
            onload: function ( error, response ) {
                if ( error ) {
                    callback(badRequestError);
                } else {
                    callback(null, response);
                }
            },
            onerror: function () {
                callback(badRequestError);
            }
        });
    },

    /**
     * Add or delete karaoke track from favorites list.
     *
     * @param {number} trackID - ID of karaoke track
     * @param {string|boolean} favoriteState - favorites flag in some form
     * @param {Function} callback - callback function
     */
    setFavoriteState: function ( trackID, favoriteState, callback ) {
        core.backend.request(config.resource + trackID, {
            method: 'PUT',
            body: favoriteState,
            onload: function ( error, response ) {
                if ( error ) {
                    callback(badRequestError);
                } else {
                    callback(null, response);
                }
            },
            onerror: function () {
                callback(badRequestError);
            }
        });
    }
};
